
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widerrufsrecht/active-sportstudio",
      function () {
        return require("private-next-pages/widerrufsrecht/active-sportstudio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widerrufsrecht/active-sportstudio"])
      });
    }
  